export const toggleBodyScroll = val => {
  const body = document.querySelector('body');
  if (val !== null && val !== undefined) {
    if (val) body.classList.remove('no-scroll');
    else body.classList.add('no-scroll');
  } else body.classList.toggle('no-scroll');
};
